import React, { createRef, useState } from "react";
import { FileModel } from "@admin/domain/files/model/FileModel";
import { makePath } from "@admin/utils/makePath";
import { uploadFile } from "@admin/domain/files/api";
import { readableFileSize } from "@admin/utils/formatters";

type Props = {
    image: FileModel | null;
};

export default function ExpertOpinionImage({ image }: Props) {
    const [expertOpinionImage, setExpertOpinionImage] = useState(image);
    const inputRef = createRef<HTMLInputElement>();

    async function loadImage(event: React.ChangeEvent<HTMLInputElement>) {
        const image = await uploadFile(event.target.files?.item(0) as File);

        setExpertOpinionImage(image);
    }

    if (expertOpinionImage) {
        return (
            <div className="card border mb-5 position-relative">
                <div className="card-body">
                    <div className="d-flex">
                        <img
                            className="me-3 img-thumbnail product_list_img"
                            src={makePath(expertOpinionImage.path)}
                            alt="image"
                        />
                        <div className="d-flex flex-column justify-content-center">
                            <div>
                                <span className="fw-bolder">Название файла:</span>
                                {` `}
                                {expertOpinionImage.name}
                            </div>
                            <div>
                                <span className="fw-bolder">Формат файла:</span>
                                {` `}
                                {expertOpinionImage.mime}
                            </div>
                            <div>
                                <span className="fw-bolder">Размер файла:</span>
                                {` `}
                                {readableFileSize(expertOpinionImage.metadata.size)}
                            </div>
                            <a className="link link-success" href={makePath(expertOpinionImage.path)} target="_blank">
                                Посмотреть
                            </a>
                            <input type="hidden" name="expert[image]" defaultValue={expertOpinionImage.id} />
                        </div>
                    </div>
                </div>
                <i
                    className="bi bi-x-circle position-absolute text-danger end-0 mt-5 me-5 cursor-pointer"
                    onClick={() => setExpertOpinionImage(null)}
                />
            </div>
        );
    }

    return (
        <div className="mb-5">
            <input className="d-none" type="file" accept="image/*" ref={inputRef} onChange={loadImage} />
            <button type="button" className="btn btn-primary" onClick={() => inputRef.current?.click()}>
                Добавить изображение
            </button>
        </div>
    );
}
